const listeners = new Set();

export function claimFriendRowMenu(id) {
    listeners.forEach((listener) => listener(id));
}

export function subscribeFriendRowMenu(listener) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
